import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';

import { useAppDispatch } from '../redux/store';

const UserResolver = lazy(() => import('@frontend/user/events').then((module) => ({ default: module.UserResolver })));
const CostCenterResolver = lazy(() => import('@frontend/cost-center/events').then((module) => ({ default: module.CostCenterResolver })));
const DeceasedResolver = lazy(() => import('@frontend/deceased/events').then((module) => ({ default: module.DeceasedResolver })));
const AccountResolver = lazy(() => import('@frontend/account/events').then((module) => ({ default: module.AccountResolver })));
const UserGroupResolver = lazy(() => import('@frontend/group/events').then((module) => ({ default: module.UserGroupResolver })));
const ProductCategoryResolver = lazy(() => import('@frontend/group/events').then((module) => ({ default: module.ProductCategoryResolver })));
const EquipmentGroupResolver = lazy(() => import('@frontend/group/events').then((module) => ({ default: module.EquipmentGroupResolver })));
const ProductGroupResolver = lazy(() => import('@frontend/group/events').then((module) => ({ default: module.ProductGroupResolver })));
const QuestionnaireResolver = lazy(() => import('@frontend/group/events').then((module) => ({ default: module.QuestionnaireResolver })));
const BudgetResolver = lazy(() => import('@frontend/budget/events').then((module) => ({ default: module.BudgetResolver })));
const SpotResolver = lazy(() => import('@frontend/spot/events').then((module) => ({ default: module.SpotResolver })));
const ModuleResolver = lazy(() => import('@frontend/module/events').then((module) => ({ default: module.ModuleResolver })));
const ModuleTemplateResolver = lazy(() => import('@frontend/module/events').then((module) => ({ default: module.ModuleTemplateResolver })));
const PlaylistResolver = lazy(() => import('@frontend/playlist/events').then((module) => ({ default: module.PlaylistResolver })));
const PlaylistItemResolver = lazy(() => import('@frontend/playlist/events').then((module) => ({ default: module.PlaylistItemResolver })));
const SlotResolver = lazy(() => import('@frontend/slot/events').then((module) => ({ default: module.SlotResolver })));
const SlotTemplateResolver = lazy(() => import('@frontend/slot/events').then((module) => ({ default: module.SlotTemplateResolver })));
const ProductResolver = lazy(() => import('@frontend/product/events').then((module) => ({ default: module.ProductResolver })));
const CertificateResolver = lazy(() => import('@frontend/certificate/events').then((module) => ({ default: module.CertificateResolver })));
const IoTResolver = lazy(() => import('@frontend/iot/events').then((module) => ({ default: module.IoTResolver })));
const EquipmentResolver = lazy(() => import('@frontend/equipment/events').then((module) => ({ default: module.EquipmentResolver })));
const DeviceResolver = lazy(() => import('@frontend/device/events').then((module) => ({ default: module.DeviceResolver })));
const WorkflowResolver = lazy(() => import('@frontend/workflow/events').then((module) => ({ default: module.WorkflowResolver })));
const UserInterfaceResolver = lazy(() => import('@frontend/user-interface/events').then((module) => ({ default: module.UserInterfaceResolver })));
const ProblemResolver = lazy(() => import('@frontend/problem/events').then((module) => ({ default: module.ProblemResolver })));
const StockResolver = lazy(() => import('@frontend/stock/events').then((module) => ({ default: module.StockResolver })));
const DocumentResolver = lazy(() => import('@frontend/document/events').then((module) => ({ default: module.DocumentResolver })));
const AttributeResolver = lazy(() => import('@frontend/attribute/events').then((module) => ({ default: module.AttributeResolver })));
const TransactionResolver = lazy(() => import('@frontend/transaction/events').then((module) => ({ default: module.TransactionResolver })));
const CustomRoleResolver = lazy(() => import('@frontend/role/events').then((module) => ({ default: module.CustomRoleResolver })));
const QuestionResolver = lazy(() => import('@frontend/question/events').then((module) => ({ default: module.QuestionResolver })));
const RequirementResolver = lazy(() => import('@frontend/stock/events').then((module) => ({ default: module.RequirementResolver })));
const PackageResolver = lazy(() => import('@frontend/package/events').then((module) => ({ default: module.PackageResolver })));
const AnswerResolver = lazy(() => import('@frontend/question/events').then((module) => ({ default: module.AnswerResolver })));
const UserCertificateResolver = lazy(() => import('@frontend/certificate/events').then((module) => ({ default: module.UserCertificateResolver })));
const EquipmentCertificateResolver = lazy(() => import('@frontend/certificate/events').then((module) => ({ default: module.EquipmentCertificateResolver })));
const ColliResolver = lazy(() => import('@frontend/colli/events').then((module) => ({ default: module.ColliResolver })));
const IdentificationResolver = lazy(() => import('@frontend/identification/events').then((module) => ({ default: module.IdentificationResolver })));

const Resolver = (props: { children: React.ReactNode }) => {
    const dispatch = useAppDispatch();
    return (
        <AsyncComponent>
            <StockResolver dispatch={dispatch} />
            <ProblemResolver dispatch={dispatch} />
            <DeviceResolver dispatch={dispatch} />
            <IoTResolver dispatch={dispatch} />
            <EquipmentResolver dispatch={dispatch} />
            <CertificateResolver dispatch={dispatch} />
            <ProductResolver dispatch={dispatch} />
            <UserResolver dispatch={dispatch} />
            <BudgetResolver dispatch={dispatch} />
            <DocumentResolver dispatch={dispatch} />
            <UserGroupResolver dispatch={dispatch} />
            <ProductGroupResolver dispatch={dispatch} />
            <ProductCategoryResolver dispatch={dispatch} />
            <QuestionnaireResolver dispatch={dispatch} />
            <EquipmentGroupResolver dispatch={dispatch} />
            <AccountResolver dispatch={dispatch} />
            <CostCenterResolver dispatch={dispatch} />
            <DeceasedResolver dispatch={dispatch} />
            <SpotResolver dispatch={dispatch} />
            <ModuleResolver dispatch={dispatch} />
            <ModuleTemplateResolver dispatch={dispatch} />
            <PlaylistResolver dispatch={dispatch} />
            <PlaylistItemResolver dispatch={dispatch} />
            <SlotResolver dispatch={dispatch} />
            <SlotTemplateResolver dispatch={dispatch} />
            <WorkflowResolver dispatch={dispatch} />
            <UserInterfaceResolver dispatch={dispatch} />
            <QuestionResolver dispatch={dispatch} />
            <AttributeResolver dispatch={dispatch} />
            <TransactionResolver dispatch={dispatch} />
            <RequirementResolver dispatch={dispatch} />
            <CustomRoleResolver dispatch={dispatch} />
            <PackageResolver dispatch={dispatch} />
            <AnswerResolver dispatch={dispatch} />
            <UserCertificateResolver dispatch={dispatch} />
            <EquipmentCertificateResolver dispatch={dispatch} />
            <ColliResolver dispatch={dispatch} />
            <IdentificationResolver dispatch={dispatch} />
            {props.children}
        </AsyncComponent>
    );
};

export default Resolver;
